// import { hazelnut } from "@mentoor.io/hazelnut-client";
import { GenericObject } from "@taager/reinforcements";

export async function captureError(_error: Error, _payload?: GenericObject) {
  // hazelnut.error(error, payload);
}
